import {createFileRoute, Outlet} from '@tanstack/react-router'
import Stack from '@mui/material/Stack';
import {useCustomerRouteOrder} from "../../../services/hooks.ts";
import {useCustomer} from "../../../services/auth.tsx";

export const Route = createFileRoute('/_auth/order/$orderId/_order')({
  component: OrderLayout,
})

function OrderLayout() {
  const customer = useCustomer();
  const routeParams = Route.useParams() as {orderId: string};
  const order = customer.findOrder(Number(routeParams.orderId));
  if (!order) {
    return null;
  }
  return (
    <Stack margin={2} gap={2}>
      <Outlet/>
    </Stack>
  );
}
